import {openPanel} from '../sidePanel-action'

import './dropDown.styl'
export function dropDown(containerId, data, className=false) {
    return openPanel(containerId, data, 'sidePanel-droDown' + (className ? ' ' + className : ''))
}

/**
 * @deprecated
 */
export const sidePanelDropDown = dropDown
